import {Item} from "@/api/models/Item";
import SummaryCard from "@/components/SummaryCard";

interface ItemMasterSummaryProps {
  itemMaster: Array<Item>
}

const ItemsMasterSummary = ({ itemMaster }: ItemMasterSummaryProps) => {
  const itemCount = itemMaster.length
  const categoryCount = new Set(itemMaster.map(item => item.分類)).size
  const invalidCount = itemMaster.filter(item => Array.isArray(item.データ不備) && item.データ不備.length > 0).length
  return (
    <div className="tw-grid tw-grid-cols-3 tw-gap-4 py-4">
    <SummaryCard
    title="品目数"
    target={itemCount}
    className="flex-1/3"
    />
    <SummaryCard
      title="分類数"
      target={categoryCount}
      className="flex-1/3"
    />
    <SummaryCard
      title="データ不備"
      target={invalidCount}
      className="flex-1/3"
    />
  </div>
  )
}

export default ItemsMasterSummary
